import { requestCommon } from 'live/lib/utils'

import { CHANNELS_BASE_URL, CHANNELS_REST_ENDPOINTS } from '../utils/constants'

export interface IChannelsListFilters {
    /** number of itens per page */
    perPage?: number
    /** page to request page start in 0 */
    page?: number
    /** field to orderBy */
    orderBy?: string
    /** orderBy Direction */
    direction?: 'ASC' | 'DESC'
    /** This will filter by operation id */
    filterBy?: number | string
    /** string to search */
    keyword?: string
}

export interface IChannelCreation extends Omit<IChannel, 'channelType'> {
    channelTypeId: string
}

export const listChannels = async (params?: IChannelsListFilters): Promise<IChannel[]> => {
    const qs = new URLSearchParams({
        limit: params?.perPage?.toString() ?? '',
        offset: (Math.max(1, params?.page ?? 1) - 1)?.toString() ?? '0',
        keyword: params?.keyword?.toString() ?? '',
        orderBy: params?.orderBy?.toString()?.toUpperCase() ?? 'ID',
        direction: params?.direction?.toString() ?? 'ASC'
    }).toString()

    return fetch(`${CHANNELS_BASE_URL}/${CHANNELS_REST_ENDPOINTS.CHANNELS}/?${qs}`, {
        ...requestCommon,
        method: 'GET'
    }).then(async data => {
        let jsonData

        try {
            jsonData = await data.json()
        } catch (err) {
            jsonData = undefined
        }

        if (data.ok) {
            return jsonData
        } else {
            throw new Error(jsonData?.Message ?? jsonData?.error ?? jsonData?.message)
        }
    })
}

export const createChannel = async (body: IChannelCreation): Promise<IChannel> => {
    return fetch(`${CHANNELS_BASE_URL}/${CHANNELS_REST_ENDPOINTS.CHANNELS}/`, {
        ...requestCommon,
        method: 'POST',
        body: JSON.stringify(body)
    }).then(async data => {
        let jsonData

        try {
            jsonData = await data.json()
        } catch (err) {
            jsonData = undefined
        }

        if (data.ok) {
            return jsonData
        } else {
            throw new Error(jsonData?.Message ?? jsonData?.error ?? jsonData?.message)
        }
    })
}

export const updateChannel = async (body: IChannel): Promise<IChannel> => {
    return fetch(`${CHANNELS_BASE_URL}/${CHANNELS_REST_ENDPOINTS.CHANNELS}/${body.id}`, {
        ...requestCommon,
        method: 'PATCH',
        body: JSON.stringify(body)
    }).then(async data => {
        let jsonData

        try {
            jsonData = await data.json()
        } catch (err) {
            jsonData = undefined
        }

        if (data.ok) {
            return jsonData
        } else {
            throw new Error(jsonData?.Message ?? jsonData?.error ?? jsonData?.message)
        }
    })
}

export const deleteChannel = async (id: string): Promise<void> => {
    if (!id) {
        throw new Error('Missing id')
    }

    return fetch(`${CHANNELS_BASE_URL}/${CHANNELS_REST_ENDPOINTS.CHANNELS}/${id}`, {
        ...requestCommon,
        method: 'DELETE'
    }).then(async data => {
        let jsonData

        try {
            jsonData = await data.json()
        } catch (err) {
            jsonData = undefined
        }

        if (data.ok) {
            return jsonData
        } else {
            throw new Error(jsonData?.Message ?? jsonData?.error ?? jsonData?.message)
        }
    })
}
